import { Injectable, OnDestroy } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, RouterEvent, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { SpinnerService } from '../service/spinner.service';
import { Subscription } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, OnDestroy {

  private unsubscribe: Subscription[] = [];

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }


  constructor(private router: Router, private authenticationService: AuthenticationService, private spinnerService: SpinnerService) {
    // to show a spinner on lazy load route
    this.unsubscribe.push(router.events.subscribe(
      (event: RouterEvent) => {

        if (event instanceof RouteConfigLoadStart) {
          this.spinnerService.show();
        } else if (event instanceof RouteConfigLoadEnd) {
          this.spinnerService.hide();
        }
      }
    ));
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    let currentUser = this.authenticationService.currentUserValue;
    if (!currentUser) {
      const jwt = localStorage.getItem("jwt");
      if (jwt) {
        this.authenticationService.login(jwt);
        currentUser = this.authenticationService.currentUserValue;
        this.authenticationService.inactivity();
      }
    }


    if (currentUser) {
      // check if route is restricted by role
      if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1) {
        // role not authorised so redirect to home page
        this.router.navigate(['/']);
        this.spinnerService.hide();
        return false;
      }
      return true;
    }
    this.spinnerService.hide();
    // not logged in so redirect to login page with the return url
    this.authenticationService.logout();
    return false;
  }
}
